<template>
  <div class="layout-nested">
    <div
      v-for="(item, idx) in safeBlocks"
      :key="item.id || idx"
      class="layout-nested__item"
      :class="'layout-nested__item--' + (item.type || 'unknown')"
    >
      <component
        :is="resolveComponent(item.type)"
        v-if="resolveComponent(item.type)"
        :data="item.data || {}"
        :class="'block-' + item.type"
      />
    </div>
  </div>
</template>

<script>
import AppHeroBlock from '@/components/Blocks/AppHeroBlock.vue'
import AppHeroNewBlock from '@/components/Blocks/AppHeroNewBlock.vue'
import AppImageTextBlock from '@/components/Blocks/AppImageTextBlock.vue'
import AppHtmlContentBlock from '@/components/Blocks/AppHtmlContentBlock.vue'
import AppEditorBlock from '@/components/Blocks/AppEditorBlock.vue'
import AppImageBlock from '@/components/Blocks/AppImageBlock.vue'
import AppAccordionListBlock from '@/components/Blocks/AppAccordionListBlock.vue'
import AppCarouselBlock from '@/components/Blocks/AppCarouselBlock.vue'
import AppStaffListBlock from '@/components/Blocks/AppStaffListBlock.vue'
import AppStaffGrid4Block from '@/components/Blocks/AppStaffGrid4Block.vue'
import AppDepartmentInfoBlock from '@/components/Blocks/AppDepartmentInfoBlock.vue'
import AppListingCardsBlock from '@/components/Blocks/AppListingCardsBlock.vue'
import AppListingServiceSectionsBlock from '@/components/Blocks/AppListingServiceSectionsBlock.vue'
import AppDepartmentListBlock from '@/components/Blocks/AppDepartmentListBlock.vue'
import AppDepartmentGalleryBlock from '@/components/Blocks/AppDepartmentGalleryBlock.vue'
import AppUnderDepartmentListBlock from '@/components/Blocks/AppUnderDepartmentListBlock.vue'
import AppDepartmentHeroBlock from '@/components/Blocks/AppDepartmentHeroBlock.vue'
import AppDepartmentAboutBlock from '@/components/Blocks/AppDepartmentAboutBlock.vue'
import AppDepartmentTripleCardsBlock from '@/components/Blocks/AppDepartmentTripleCardsBlock.vue'
import AppDepartmentFactsBlock from '@/components/Blocks/AppDepartmentFactsBlock.vue'
import AppDepartmentContactsBlock from '@/components/Blocks/AppDepartmentContactsBlock.vue'
import AppDepartmentFactsContactsBlock from '@/components/Blocks/AppDepartmentFactsContactsBlock.vue'
import AppThankYouBlock from '@/components/Blocks/AppThankYouBlock.vue'
import AppPaidServicesListingBlock from '@/components/Blocks/AppPaidServicesListingBlock.vue'
import AppFrequentSearchesBlock from '@/components/Blocks/AppFrequentSearchesBlock.vue'

const NESTED_COMPONENTS = {
  hero: 'AppHeroBlock',
  hero_new: 'AppHeroNewBlock',
  image_text: 'AppImageTextBlock',
  html_content: 'AppHtmlContentBlock',
  editor: 'AppEditorBlock',
  image: 'AppImageBlock',
  accordion_list: 'AppAccordionListBlock',
  carousel: 'AppCarouselBlock',
  staff_list: 'AppStaffListBlock',
  staff_grid_4: 'AppStaffGrid4Block',
  department_info: 'AppDepartmentInfoBlock',
  listing_cards: 'AppListingCardsBlock',
  listing_service_sections: 'AppListingServiceSectionsBlock',
  department_list: 'AppDepartmentListBlock',
  department_gallery: 'AppDepartmentGalleryBlock',
  under_department_list: 'AppUnderDepartmentListBlock',
  department_hero: 'AppDepartmentHeroBlock',
  department_about: 'AppDepartmentAboutBlock',
  department_triple_cards: 'AppDepartmentTripleCardsBlock',
  department_facts: 'AppDepartmentFactsBlock',
  department_contacts: 'AppDepartmentContactsBlock',
  department_facts_contacts: 'AppDepartmentFactsContactsBlock',
  thank_you: 'AppThankYouBlock',
  paid_services_listing: 'AppPaidServicesListingBlock',
  frequent_searches: 'AppFrequentSearchesBlock',
  // layout_grid / layout_columns намеренно не вложены (рекурсия)
}

export default {
  name: 'AppLayoutNestedContent',
  components: {
    AppHeroBlock,
    AppHeroNewBlock,
    AppImageTextBlock,
    AppHtmlContentBlock,
    AppEditorBlock,
    AppImageBlock,
    AppAccordionListBlock,
    AppCarouselBlock,
    AppStaffListBlock,
    AppStaffGrid4Block,
    AppDepartmentInfoBlock,
    AppListingCardsBlock,
    AppListingServiceSectionsBlock,
    AppDepartmentListBlock,
    AppDepartmentGalleryBlock,
    AppUnderDepartmentListBlock,
    AppDepartmentHeroBlock,
    AppDepartmentAboutBlock,
    AppDepartmentTripleCardsBlock,
    AppDepartmentFactsBlock,
    AppDepartmentContactsBlock,
    AppDepartmentFactsContactsBlock,
    AppThankYouBlock,
    AppPaidServicesListingBlock,
    AppFrequentSearchesBlock,
  },
  props: {
    blocks: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    safeBlocks() {
      return (this.blocks || []).filter((b) => b && b.type && NESTED_COMPONENTS[b.type])
    },
  },
  methods: {
    resolveComponent(type) {
      return NESTED_COMPONENTS[type] || null
    },
  },
}
</script>

<style scoped lang="scss">
.layout-nested {
  &__item {
    min-width: 0;

    & + & {
      margin-top: 16px;
    }
  }

  // Убираем лишние внешние отступы блоков внутри узкой ячейки
  :deep(.layout-grid-block),
  :deep(.layout-columns) {
    padding: 0;
  }

  :deep(section) {
    max-width: 100%;
  }
}
</style>
